import { useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import {
  editProduct,
  addRelatedProduct,
  removeRelatedProduct,
} from "../../../../services/products";
import { NETWORK } from "../../../../settings";
import { notify } from "../../../../redux/features/alert";
import FirstTab from "./modal-tabs/firstTab";
import SecondTab from "./modal-tabs/secondTab";
import ExtrasTab from "./modal-tabs/extrasTab";
import SizesTab from "./modal-tabs/sizesTab";
import RelatedProductsTab from "./modal-tabs/relatedProductsTab";
import ReturnTabHeaders from "./modal-tabs/modalTabHeaders";
import { makeStyles } from "@mui/styles";
import { Modal, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import CreateCategoryModal from "../../categories/createCategoryModal";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}
const useStyles = makeStyles({
  activeButton: {
    margin: "0 5px",
    color: "#fff",
    border: "none",
    backgroundColor: "#124c4d",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
});
export default function ModalEditProduct({
  open,
  handleClose,
  artists,
  categories,
  ingredients,
  products,
  refresh,
  store,
  product,
  attemptClose,
  getCategories,
}) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const onClose = () => {
    setName("");
    setNewProductImages([]);
    setNameError("");
    setPrice(0);
    setStock(0);
    // setCost(0.0);
    setMeasureError("");
    setSlugError("");
    // setCostError('');
    setDescription("");
    setAllergyNotes("");
    setMeasure("");
    setCategory("");
    setImageSource("");
    setExtras([]);
    setCategoryError("");
    setSizes([]);
    setProductImages([]);
    setProductSheet(null);
    setOrigin("");
    setHexCode("");
    refresh();
    setActiveTab(0);
    setSlug("");
    setArtistName("");
    setMaterial("");
    setSku("");
    setBarcode("");
    setNewCategory(false);
    setChanged(false);
    setFiscalCategory("PRODUCT")
    handleClose();
  };
  const fillRelatedProducts = () => {
    if (product?.product_id) {
      var filteredProducts = [];
      product.related_products.forEach((related) => {
        var selectedRelated = products.filter(
          (element) => element.product_id === related.related_product.product_id
        );
        filteredProducts.push(selectedRelated[0]);
      });
      setSelectedProducts(filteredProducts);
    }
  };
  useEffect(() => {
    if (product) {
      fillRelatedProducts();
      setName(product.name);
      setPrice(product.price);
      // setCost(product.cost);
      setStock(product.stock);
      setDescription(product.description);
      setAllergyNotes(product.allergy_notes);
      setMeasure(product.measure);
      setCategory(product.category);
      setImageSource(product.image);
      setVideo(product.video);
      setFiscalCategory(product.fiscal_category)
      setActive(product.active);
      setSlug(product.slug);
      if (product.product_images) {
        var images = [];
        product.product_images.map((image) => {
          images.push({
            deleted: false,
            image: image,
          });
        });
        setProductImages(images);
      }
      if (product["variation"]) {
        var _sizes = product["variation"].map((_size) => ({
          ..._size,
          changed: false,
        }));
        setSizes(_sizes);
      }
      setHexCode(product.colour_hex);
      setExtras(product.extras);
      setSku(product.sku);
      setBarcode(product.barcode);
      if (NETWORK === "6") {
        setMaterial(product.material);
        setProductSheet(product.product_sheet);
        setOrigin(product.origin);
        const artist = artists.find(
          (artist) => artist.artist_id === product.artist
        );
        if (artist?.name) {
          setArtistName(artist.artist_id);
        }
      }
      handleMaps();
    }
  }, [product]);
  const handleMaps = () => {
    const newExtras = [];

    for (let index = 0; index < product.extras.length; index++) {
      const element = product.extras[index];
      newExtras.push({
        extra_id: index,
        id: element.id,
        is_sauce: element.is_sauce === false ? 0 : 1,
        limit: element.limit,
        price: element.price,
        ingredient: element.ingredient_id,
        quantity: element.quantity,
        isOld: true,
      });
    }
    setExtras(newExtras);
  };
  const options = categories.map((_category) => {
    return _category.name;
  });
  const [activeTab, setActiveTab] = useState(0);
  const [imageSource, setImageSource] = React.useState("");
  const [name, setName] = React.useState("");
  const [nameError, setNameError] = React.useState("");
  const [slugError, setSlugError] = React.useState("");
  const [measure, setMeasure] = React.useState("Unit");
  const [measureError, setMeasureError] = React.useState("");
  const [category, setCategory] = React.useState("");
  const [categoryError, setCategoryError] = React.useState("");
  const [price, setPrice] = React.useState(0);
  const [slug, setSlug] = React.useState("");
  const [video, setVideo] = React.useState();
  const [extras, setExtras] = React.useState([]);
  const [extrasError, setextrasError] = React.useState("");
  const [stock, setStock] = React.useState(0);
  const [description, setDescription] = React.useState("");
  const [allergyNotes, setAllergyNotes] = React.useState("");
  const [sizes, setSizes] = React.useState([]);
  const [sizesError, setSizesError] = React.useState(false);
  const [artistName, setArtistName] = React.useState("");
  const [artistNameError, setArtistNameError] = React.useState("");
  const [origin, setOrigin] = React.useState("");
  const [originError, setOriginError] = React.useState("");
  const [productImages, setProductImages] = React.useState([]);
  const [hexCode, setHexCode] = useState("");
  const [hexCodeError, setHexCodeError] = React.useState("");
  const [productSheet, setProductSheet] = React.useState(null);
  const [material, setMaterial] = React.useState("");
  const [materialError, setMaterialError] = React.useState("");
  const [duplicateSlugError, setDuplicateSlugError] = useState("");
  const [newProductImages, setNewProductImages] = React.useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [removedProducts, setRemovedProducts] = useState([]);
  const [sku, setSku] = useState("");
  const [barcode, setBarcode] = useState("");
  const [active, setActive] = useState(true);
  const [newCategory, setNewCategory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [changed, setChanged] = useState(false);
  const [fiscalCategory, setFiscalCategory] = useState("PRODUCT")

  const generateURL = (file) => {
    if (file.image) return file.image.image;
    if (typeof file === "string") return file;
    var url = URL.createObjectURL(file);
    return url;
  };
  const checkDuplicateSlug = () => {
    const currentSlug = product.slug;
    for (let index = 0; index < products.length; index++) {
      const product_el = products[index];
      if (product_el.slug === slug && product_el.slug !== currentSlug) {
        return true;
      }
    }
    return false;
  };
  const checkForm = () => {
    let entered = false;
    if (name === "") {
      setNameError("Please insert a name");
      entered = true;
    }
    if (category === "" || category === null || !category) {
      setCategoryError("Please insert a category");
      entered = true;
    }
    if (checkDuplicateSlug()) {
      setDuplicateSlugError(
        "You already have a product with this friendly URL"
      );
      entered = true;
    }
    if (slug === "") {
      setSlugError("Please insert the friendly URL");
      entered = true;
    }
    if (measure === "" || measure === null) {
      setMeasureError("Please insert a unit");
      entered = true;
    }
    sizes.map((element) => {
      if (element.name === "") {
        setSizesError(true);
        entered = true;
      }
    });
    if (NETWORK !== "6") {
      extras.map((element) => {
        if (element.ingredient === 0 || element.price === "") {
          setextrasError("Please fill all fields in extras");
          entered = true;
        }
      });
    }
    if (NETWORK === "6") {
      if (material === "" || material === null) {
        setMaterialError("Please insert the material");
        entered = true;
      }
      if (hexCode === "" || hexCode === null) {
        setHexCodeError("Please insert the hex code");
        entered = true;
      }
      if (artistName === "" || artistName === null) {
        setArtistNameError("Please insert the artist");
        entered = true;
      }
      if (origin === "" || origin === null) {
        setOriginError("Please insert the origin");
        entered = true;
      }
    }

    if (entered) {
      dispatch(
        notify({ message: "Please insert all the names", severity: "error" })
      );
    }
    return entered;
  };
  const showMeasure = (id) => {
    var measure = "";
    for (let index = 0; index < ingredients.length; index++) {
      const element = ingredients[index];
      if (element.ingredient_id === id) {
        measure = element.measure;
      }
    }
    return measure;
  };
  const handleRelatedProducts = () => {
    return new Promise((resolve, reject) => {
      if (removedProducts.length === 0 && selectedProducts.length === 0) {
        resolve();
      } else {
        Promise.all([handleRemovedProducts(), handleAddedProducts()])
          .then(() => {
            resolve();
          })
          .catch((e) => {
            console.log("error related", e);
            reject();
          });
      }
    });
  };
  const submitEdit = async (e) => {
    e.preventDefault();
    if (!checkForm()) {
      setLoading(true);
      var oldExtras = [];
      var oldIngredients = [];
      var extrasNew = [];
      var ingredientsNew = [];
      for (let index = 0; index < ingredients.length; index++) {
        const element = ingredients[index];
        if (element.isOld === true) {
          oldIngredients.push({
            quantity: element.quantity,
            measure: element.measure,
            ingredient_id: element.ingredient_id,
            stock: element.stock_id,
          });
        } else {
          ingredientsNew.push({
            ingredient_id: element.ingredient_id,
            ingredient_stock: {
              measure: showMeasure(element.ingredient_id),
              quantity: element.quantity * 1,
            },
          });
        }
      }

      for (let index = 0; index < extras.length; index++) {
        const element = extras[index];
        if (element.isOld === true) {
          oldExtras.push({
            ingredient_id_new: element.ingredient,
            quantity: element.quantity,
            limit: element.limit,
            price: element.price,
            id: element.id,
            is_sauce: element.is_sauce === 0 ? false : true,
            deleted: element.deleted ? true : false,
          });
        } else {
          extrasNew.push({
            ingredient_id: element.ingredient,
            extra: {
              limit: element.limit,
              price: element.price,
              is_sauce: element.is_sauce === 0 ? false : true,
              measure: showMeasure(element.ingredient),
              quantity: element.quantity,
            },
          });
        }
      }
      var imagesToSubmit = [...productImages, ...newProductImages];

      var payload = {
        image: imageSource,
        video: video,
        name: name,
        price: price,
        stock: stock,
        // cost: cost,
        description: description,
        category: category,
        allergy_notes: allergyNotes,
        measure: measure,
        oldExtras: oldExtras,
        oldIngredients: oldIngredients,
        newIngredients: ingredientsNew,
        newExtras: extrasNew,
        store: store,
        slug: slug,
        size: sizes,
        artist: artistName,
        origin: origin,
        product_sheet: productSheet,
        colour_hex: hexCode,
        network: NETWORK,
        product_images: imagesToSubmit,
        material: material,
        active: active,
        fiscal_category: fiscalCategory

      };
      if (typeof payload.image === "string") {
        delete payload.image;
      }
      if (!video) {
        delete payload.video;
      }
      if (NETWORK !== "6") {
        delete payload.product_sheet;
        delete payload.origin;
        delete payload.artist;
      }
      if (!productSheet || typeof productSheet === "string") {
        delete payload.product_sheet;
      }
      editProduct(payload, product.product_id)
        .then(() => {
          handleRelatedProducts()
            .then(() => {
              setLoading(false);

              dispatch(
                notify({
                  message: "Product successfully edited",
                  severity: "success",
                })
              );

              onClose();
            })
            .catch((error) => {
              setLoading(false);

              dispatch(
                notify({
                  message: "An error occurred while updating the order",
                  severity: "error",
                })
              );
            });
        })
        .catch((error) => {
          setLoading(false);
          dispatch(
            notify({
              message: "An error occurred while updating the order",
              severity: "error",
            })
          );
        });
    }
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const renderFirstTab = () => (
    <FirstTab
      options={options}
      name={name}
      setName={(e) => {
        setName(e);
        setChanged(true);
      }}
      nameError={nameError}
      slug={slug}
      slugError={slugError}
      category={category}
      setCategory={(e) => {
        setCategory(e);
        setChanged(true);
      }}
      categoryError={categoryError}
      price={price}
      setPrice={(e) => {
        setPrice(e);
        setChanged(true);
      }}
      stock={stock}
      setStock={(e) => {
        setStock(e);
        setChanged(true);
      }}
      measure={measure}
      setMeasure={(e) => {
        setMeasure(e);
        setChanged(true);
      }}
      measureError={measureError}
      artistName={artistName}
      artistNameError={artistNameError}
      setArtistName={(e) => {
        setArtistName(e);
        setChanged(true);
      }}
      setActive={(e) => {
        setActive(e);
        setChanged(true);
      }}
      active={active}
      origin={origin}
      originError={originError}
      setOrigin={(e) => {
        setOrigin(e);
        setChanged(true);
      }}
      hexCode={hexCode}
      hexCodeError={hexCodeError}
      setHexCode={(e) => {
        setHexCode(e);
        setChanged(true);
      }}
      material={material}
      materialError={materialError}
      setMaterial={(e) => {
        setMaterial(e);
        setChanged(true);
      }}
      imageSource={imageSource}
      setImageSource={(e) => {
        setImageSource(e);
        setChanged(true);
      }}
      video={video}
      setVideo={(e) => {
        setVideo(e);
        setChanged(true);
      }}
      productSheet={productSheet}
      setProductSheet={(e) => {
        setProductSheet(e);
        setChanged(true);
      }}
      description={description}
      setDescription={(e) => {
        setDescription(e);
        setChanged(true);
      }}
      generateURL={generateURL}
      categories={categories}
      artists={artists}
      setSlug={(e) => {
        setSlug(e);
        setChanged(true);
      }}
      duplicateSlugError={duplicateSlugError}
      setDuplicateSlugError={setDuplicateSlugError}
      variations={sizes.filter((size) => !size.deleted).length}
      setNewCategory={() => setNewCategory(true)}
      fiscalCategory={fiscalCategory}
      setFiscalCategory={(e) => setFiscalCategory(e)}
    />
  );
  const renderSecondTab = () => {
    return (
      <SecondTab
        productImages={productImages}
        setProductImages={(images) => {
          setChanged(true);
          setProductImages((oldArray) => [...oldArray, ...images]);
        }}
        removeImage={(idx) => {
          setChanged(true);
          var _images = [...productImages];
          if (!_images[idx].image) {
            _images.splice(idx, 1);
          } else {
            _images[idx].deleted = true;
          }
          setProductImages(_images);
        }}
        generateURL={generateURL}
        imageSource={imageSource}
        setImageSource={(e) => {
          setImageSource(e);
          setChanged(true);
        }}
        video={video}
        setVideo={(e) => {
          setVideo(e);
          setChanged(true);
        }}
        productSheet={productSheet}
        setProductSheet={(e) => {
          setProductSheet(e);
          setChanged(true);
        }}
      />
    );
  };

  const renderExtrasTab = () => {
    return (
      <ExtrasTab
        extras={extras}
        setExtras={(e) => {
          setExtras(e);
          setChanged(true);
        }}
        handleChange={(prop, index, value) => {
          setChanged(true);
          setExtras(
            extras.map((item) =>
              item.extra_id === index
                ? {
                  ...item,
                  [prop]: value,
                }
                : item
            )
          );
        }}
        extrasError={extrasError}
        ingredients={ingredients}
      />
    );
  };

  const renderSizesTab = () => {
    return (
      <SizesTab
        sizes={sizes}
        setSizes={(newValue) => {
          setChanged(true);
          var stockSum = 0;
          newValue.map((el) => {
            if (!el.deleted) stockSum += Number(el.stock);
          });
          setStock(stockSum);
          setSizes(newValue);
        }}
        sizesError={sizesError}
      />
    );
  };

  const pushRemove = (product_id) => {
    var removed = [];
    removedProducts.map((el) => {
      if (!removed.includes(el)) {
        removed.push(el);
      }
    });
    if (!removed.includes(product_id)) {
      removed.push(product_id);
    }
    setRemovedProducts(removed);
  };
  const deleteRemove = (product_id) => {
    var removed = [];
    removedProducts.map((el) => {
      if (el !== product_id) {
        removed.push(el);
      }
    });
    setRemovedProducts(removed);
  };
  const handleProductUnPressAll = () => {
    setRemovedProducts(
      selectedProducts.map((_product) => {
        return _product.product_id;
      })
    );
    setSelectedProducts([]);
  };
  const handleProductOnPress = (selectedProduct) => {
    if (
      selectedProducts
        .map((productToAdd) => productToAdd.product_id)
        .includes(selectedProduct.product_id)
    ) {
      return setSelectedProducts(
        selectedProducts.filter(
          (prod) => prod.product_id !== selectedProduct.product_id
        )
      );
    }
    return setSelectedProducts([selectedProduct, ...selectedProducts]);
  };
  const handleRemovedProducts = async () => {
    return new Promise((resolve, reject) => {
      try {
        if (removedProducts.length === 0) {
          resolve();
        }
        removedProducts.map((el, idx) => {
          removeRelatedProduct(el, product.product_id);
          if (idx === removeRelatedProduct.length - 1) {
            resolve();
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  };
  const handleAddedProducts = async () => {
    return new Promise((resolve, reject) => {
      try {
        if (selectedProducts.length === 0) {
          resolve();
        }
        selectedProducts.map((el, idx) => {
          addRelatedProduct(el.product_id, product.product_id);
          if (idx === selectedProducts.length - 1) {
            resolve();
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  };
  const returnTabsBody = () => {
    switch (NETWORK) {
      case "6":
        return (
          <>
            <TabPanel value={activeTab} index={0}>
              {renderFirstTab()}
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
              {renderSecondTab()}
            </TabPanel>
            <TabPanel value={activeTab} index={2}>
              {renderSizesTab()}
            </TabPanel>
          </>
        );

      default:
        return (
          <>
            <TabPanel value={activeTab} index={0} className="px-10">
              {renderFirstTab()}
            </TabPanel>
            <TabPanel value={activeTab} index={1} className="px-10">
              {renderSecondTab()}
            </TabPanel>
            <TabPanel value={activeTab} index={2} className="px-10">
              {renderExtrasTab()}
            </TabPanel>
            <TabPanel value={activeTab} index={3}>
              <Typography className="table-cell px-10">Variation</Typography>
              {renderSizesTab()}
            </TabPanel>
            <TabPanel value={activeTab} index={4} className="px-10">
              <RelatedProductsTab
                products={products}
                selectedProducts={selectedProducts}
                pushRemove={pushRemove}
                handleProductOnPress={handleProductOnPress}
                removedProducts={removedProducts}
                deleteRemove={deleteRemove}
              />
            </TabPanel>
          </>
        );
    }
  };
  const buttonTitle = () => {
    switch (NETWORK) {
      case "6":
        if (activeTab > 2) {
          return "Submit";
        }
        return "Next";

      default:
        if (activeTab > 3) {
          return "Submit";
        }
        return "Next";
    }
  };
  const handleNavigation = (e) => {
    switch (NETWORK) {
      case "6":
        if (activeTab <= 1) {
          setActiveTab(activeTab + 1);
        } else {
          submitEdit(e);
        }
      default:
        if (activeTab <= 3) {
          setActiveTab(activeTab + 1);
        } else {
          submitEdit(e);
        }
    }
  };
  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const closeModal = () => {
    if (changed) {
      attemptClose()
      setActiveTab(0)
    } else {
      onClose()
    }
  }
  useEffect(() => {
    var wrapper = document.getElementById("modal-wrapper");
    if (wrapper) wrapper.scrollTo(0, 0);
  }, [activeTab]);
  return (
    <>
      <CreateCategoryModal
        open={newCategory}
        handleClose={() => setNewCategory(false)}
        refresh={() => getCategories()}
        ingredientsToFilterBy={[]}
        embedModal={true}
        store={store}
        getNewCategory={(e) => setCategory(e)}
      />
      <Modal
        className="flex flex-row h-full  items-center justify-center"
        open={open}
        onClose={() => {
          if (changed) attemptClose();
          else onClose();
        }}
      >
        <div className="w-full sm:w-[70%] md:w-[50%]  h-full sm:h-3/4 bg-white overflow-hidden relative">
          <div
            id="modal-wrapper"
            className="w-full  h-full overflow-y-auto pt-5 pb-10"
          >
            <div className="px-10">
              <div className="w-full flex flex-row items-center justify-between">
                <Typography className="borderless-title">
                  Edit product
                </Typography>
                <IconButton
                  onClick={() => {
                    closeModal()
                  }}
                  style={{
                    backgroundColor: "#fff",
                    fill: "#fff",
                    border: "1px solid #DDDDDD",
                    borderRadius: "50%",
                    height: "30px",
                    width: "30px",
                  }}
                >
                  <Close style={{ fill: "#DDDDDD" }} />{" "}
                </IconButton>
              </div>
              <div className="mt-5 bg-gray w-full mb-5 overflow-x-hidden">
                <ReturnTabHeaders
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
              </div>
            </div>
            <div className="px-10">{returnTabsBody()}</div>
          </div>
          <div className="flex justify-end absolute bg-[#612EF2] w-full h-full mt-[-60px] px-8 py-[.9rem] z-10">
            <button
              onClick={(e) => handleNavigation(e)}
              disabled={loading}
              className="text-white rounded-full border disabled:opacity-50 flex justify-center items-center h-[28px] p-4 "
            >
              <Typography style={{ marginTop: "0", color: "#F2F2F2" }}>
                {buttonTitle()}
              </Typography>
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
